var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#CBC8D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 12.25C21.2366 12.25 20.9924 12.3882 20.8569 12.6141L19.3569 15.1141C19.2033 15.3702 19.2161 15.693 19.3897 15.9359L21.3373 18.6625C17.8068 19.7891 15.25 23.096 15.25 27C15.25 31.8325 19.1675 35.75 24 35.75C28.8325 35.75 32.75 31.8325 32.75 27C32.75 23.096 30.1932 19.7891 26.6627 18.6625L28.6103 15.9359C28.7839 15.693 28.7967 15.3702 28.6431 15.1141L27.1431 12.6141C27.0076 12.3882 26.7634 12.25 26.5 12.25H21.5ZM24 18.25H25.114L27.1039 15.4642L26.0754 13.75H21.9246L20.8961 15.4642L22.886 18.25H24ZM24 19.75C19.9959 19.75 16.75 22.9959 16.75 27C16.75 31.0041 19.9959 34.25 24 34.25C28.0041 34.25 31.25 31.0041 31.25 27C31.25 22.9959 28.0041 19.75 24 19.75Z",
    fill: "#3F3754"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.c809332ea498e6a2f6cc9c0fd5903869.svg";
export { ForwardRef as ReactComponent };